// Helpers
import _ from 'lodash'
import { mapState } from 'vuex'

export const opportunityLocationsWatchers = {
  data() {
    return {
      geoCenter: null,
      filters: {
        bounds: null,
        matchesOnly: false,
      },
      storeAction: 'candidate/opportunityLocations/updateFilters',
    }
  },

  computed: mapState('candidate/opportunityLocations', { storeFilters: 'filters' }),

  watch: {
    geoCenter() {
      this.fetch()
    },

    filters: {
      handler() {
        this.fetch()
      },
      deep: true,
    },
  },

  methods: {
    fetch: _.debounce(function() {
      const filters = { ...this.storeFilters, ...this.filters }
      return this.$store
        .dispatch('candidate/opportunityLocations/search', { filters, geoCenter: this.geoCenter })
        .then(this.postFetchCallBack)
    }, 500),

    postFetchCallBack() { },
  },
}

export default {
  opportunityLocationsWatchers,
}
